import React, { Component } from "react";
import PropTypes from "prop-types";
import FilterByImage from "./FilterByImage";
import FilterByTime from "./FilterByTime";
import FilterByAlbum from "./FilterByAlbum";
import FilterByPhotographer from "./FilterByPhotographer";
import FilterByText from "./FilterByText";
import FilterByFavorite from "./FilterByFavorite";
const toggle = require("../../styles/toggleIn.svg");
import Telemetry from "../../../../utils/rudderstackAnalytics";
import { Event } from "../types";

interface FiltersContainerProps {
  filterSelections: { [key: string]: any };
  photoTimeRange: {
    min: number;
    max: number;
  };
  filterOptions: {
    albums: [];
    photographers: [];
  };
  updateFilters: Function;
  resetFilter: Function;
  clearSelfie: Function;
  photoBundleDiscountAvailed?: boolean;
  toggleSidebar: Function;
  width: number;
  selfieFilterExpanded: boolean;
  timeFilterExpanded: boolean;
  albumFilterExpanded: boolean;
  photographerFilterExpanded: boolean;
  bibFilterExpanded: boolean;
  favoritesFilterExpanded: boolean;
  collapseFilter: Function;
  changeZindex: Function;
  setClearCartPopup: Function;
  isPhotoIndexingDisabled: boolean;
  getReferenceImage: () => string | null;
  cartCount?: number;
  browsePhotosPath: string;
  selectedImage: string | null;
  event: Event;
  activeFilters: Function;
}
interface FiltersContainerState {}

class FiltersContainer extends Component<
  FiltersContainerProps,
  FiltersContainerState
> {
  static contextTypes = {
    enableFilterByText: PropTypes.bool,
    photoBundleDiscountEventId: PropTypes.number,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string
    }),
    hidePhotographersFilter: PropTypes.bool,
    isEmbed: PropTypes.bool,
    albumModeID: PropTypes.string
  };
  state = {
    selectedImage: this.props.selectedImage
  };

  updateFilters =
    (filterType: string, clearFilters: boolean) => (newValue: any) => {
      this.props.updateFilters(
        {
          [filterType]: newValue
        },
        clearFilters
      );
    };

  updatePhotographersFilter = (newValue: any) => {
    this.props.updateFilters(
      {
        photographers: newValue,
        albums: []
      },
      false
    );
  };

  updateAlbumsFilter = (newValue: any) => {
    this.props.updateFilters(
      {
        albums: newValue,
        photographers: []
      },
      false
    );
  };

  updateFavoritesFilter = (selected: boolean) => {
    this.props.updateFilters({ favoritesSelected: selected });
  };

  resetFilters = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    this.props.resetFilter();
  };

  static getDerivedStateFromProps(props: any, state: any) {
    return { selectedImage: props.selectedImage };
  }

  trackFilterEvents = (filterType: string) => {
    Telemetry.track("event-gallery:filter-applied", {
      eventId: this.props.event.id,
      eventName: this.props.event.name,
      filterType: filterType,
      embeddedMode: this.context.isEmbed
    });
    if (this.props.event.isPrivate && filterType === "selfie") {
      Telemetry.track("event-gallery:private-event:selfie-uploaded", {
        eventId: this.props.event.id,
        eventName: this.props.event.name,
        eoUserId: this.props.event.eoUserId
      });
    }
  };

  shouldShowClearFilters = () => {
    if (!this.props.activeFilters || typeof this.props.activeFilters !== 'function') {
      return false;
    }

    if (this.context.albumModeID) {
      return (
        this.props.activeFilters().includes("albums") &&
        this.props.activeFilters().length > 1
      );
    }

    return this.props.activeFilters().length > 0;
  };

  render() {
    return (
      <div className="dv-eventsfilter" id="dv-eventfilter">
        <div className="filter-head-border">
          <div className="dv-filterhead">
            <span className="dv-filterby">
              <svg
                className="filter-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.9514 0.205411C13.9162 0.143328 13.8639 0.0914293 13.7999 0.0552527C13.736 0.0190762 13.6628 -2.07112e-05 13.5882 1.68559e-08H0.411785C0.337254 -3.47279e-06 0.264119 0.0190983 0.200181 0.0552681C0.136242 0.091438 0.0838967 0.143319 0.048727 0.20538C0.0135574 0.267441 -0.00311762 0.337353 0.000480104 0.407661C0.00407782 0.477969 0.0278134 0.546037 0.0691557 0.604605L4.94119 7.5066V13.6111C4.94126 13.7142 4.98466 13.8131 5.06187 13.886C5.13907 13.9589 5.24377 13.9999 5.35296 14C5.38658 14.0001 5.42009 13.9962 5.45268 13.9883L8.7468 13.2106C8.8359 13.1895 8.91501 13.141 8.97155 13.0727C9.02809 13.0043 9.05881 12.9201 9.05883 12.8333V7.5066L13.9309 0.604528C13.9722 0.54596 13.9959 0.477921 13.9995 0.407644C14.0031 0.337366 13.9865 0.267478 13.9514 0.205411Z"
                  fill={this.context.pageConfiguration.primaryColor}
                />
              </svg>
              <span
                style={{
                  color: this.context.pageConfiguration.primaryColor,
                  fontSize: "13px"
                }}
              >
                Filter By
              </span>
            </span>
            <span>
              {this.shouldShowClearFilters() && (
                <a className="a-clear" onClick={e => this.resetFilters(e)}>
                  <span className="fa fa-refresh" /> Clear all filters
                </a>
              )}
              {this.props.width > 992 && (
                <img
                  className="toggleIn-img"
                  onClick={() => this.props.toggleSidebar()}
                  src={toggle}
                />
              )}
            </span>
          </div>
        </div>
        <div id="filter-accordion">
          <div className="filter-border">
            <FilterByImage
              updateFilter={this.updateFilters("referenceImage", false)}
              selectedImage={this.state.selectedImage}
              similarity={70}
              photoBundleDiscountAvailed={this.props.photoBundleDiscountAvailed}
              cartCount={this.props.cartCount}
              browsePhotosPath={this.props.browsePhotosPath}
              expanded={this.props.selfieFilterExpanded}
              changeZindex={this.props.changeZindex}
              collapseFilter={this.props.collapseFilter}
              clearSelfie={this.props.clearSelfie}
              isPhotoIndexingDisabled={this.props.isPhotoIndexingDisabled}
              getReferenceImage={this.props.getReferenceImage}
              isActive={this.props.filterSelections.referenceImage}
              pageConfig={this.context.pageConfiguration}
              trackFilterEvents={this.trackFilterEvents}
              setClearCartPopup={this.props.setClearCartPopup}
            />
          </div>
          <div className="filter-border">
            <FilterByFavorite
              updateFilter={this.updateFavoritesFilter}
              expanded={this.props.favoritesFilterExpanded}
              collapseFilter={this.props.collapseFilter}
              isActive={this.props.filterSelections.favoritesSelected}
              pageConfig={this.context.pageConfiguration}
              trackFilterEvents={this.trackFilterEvents}
            />
          </div>
          <div className="filter-border">
            <FilterByTime
              photoTimeRange={this.props.photoTimeRange}
              updateFilter={this.updateFilters("photoTime", false)}
              selectedTime={this.props.filterSelections.photoTime}
              expanded={this.props.timeFilterExpanded}
              collapseFilter={this.props.collapseFilter}
              isActive={this.props.filterSelections.photoTime.active}
              pageConfig={this.context.pageConfiguration}
              trackFilterEvents={this.trackFilterEvents}
            />
          </div>
          {!this.context.albumModeID && (
            <div className="filter-border">
              <FilterByAlbum
                albums={this.props.filterOptions.albums}
                updateFilter={this.updateAlbumsFilter}
                selectedAlbums={this.props.filterSelections.albums}
                expanded={this.props.albumFilterExpanded}
                collapseFilter={this.props.collapseFilter}
                isActive={this.props.filterSelections.albums.length > 0}
                pageConfig={this.context.pageConfiguration}
                trackFilterEvents={this.trackFilterEvents}
              />
            </div>
          )}

          {this.context.enableFilterByText ? (
            <div className="filter-border">
              <FilterByText
                updateFilter={this.updateFilters("photoText", false)}
                currentText={this.props.filterSelections.photoText}
                expanded={this.props.bibFilterExpanded}
                collapseFilter={this.props.collapseFilter}
                isActive={this.props.filterSelections.photoText}
                pageConfig={this.context.pageConfiguration}
                trackFilterEvents={this.trackFilterEvents}
              />
            </div>
          ) : null}
          {!this.context.hidePhotographersFilter ? (
            <div className="filter-border">
              <FilterByPhotographer
                updateFilter={this.updatePhotographersFilter}
                photographersList={this.props.filterOptions.photographers}
                selectedPhotographers={
                  this.props.filterSelections.photographers
                }
                expanded={this.props.photographerFilterExpanded}
                collapseFilter={this.props.collapseFilter}
                isActive={this.props.filterSelections.photographers.length > 0}
                pageConfig={this.context.pageConfiguration}
                trackFilterEvents={this.trackFilterEvents}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default FiltersContainer;
